import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MobileSpinnerComponent } from "../../shell/mobile-spinner/mobile-spinner.component";
import { MobileVoicePurchaseRequestRecorderComponent } from "../../voice-purchase-request/mobile-voice-purchase-request-recorder/mobile-voice-purchase-request-recorder.component";
import type { IMobileAiQuestionnaireClarifyMessage } from "../models/mobile-ai-questionnaire.models";

@Component({
  selector: "mobile-ai-questionnaire-clarify-chat",
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, MobileSpinnerComponent, MobileVoicePurchaseRequestRecorderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./mobile-ai-questionnaire-clarify-chat.component.html",
  styleUrl: "./mobile-ai-questionnaire-clarify-chat.component.scss",
})
export class MobileAiQuestionnaireClarifyChatComponent {
  readonly messages = input.required<IMobileAiQuestionnaireClarifyMessage[]>();
  readonly requiresMoreClarification = input(true);
  readonly loading = input(false);
  readonly contextLabel = input<string | null>(null);

  readonly answerSubmitted = output<string>();
  readonly generateRequested = output<void>();
  readonly recordError = output<string>();

  protected readonly answerText = signal("");
  protected readonly showVoiceRecorder = signal(false);

  protected submitTextAnswer(): void {
    const text = this.answerText().trim();
    if (!text || this.loading()) {
      return;
    }
    this.answerText.set("");
    this.showVoiceRecorder.set(false);
    this.answerSubmitted.emit(text);
  }

  protected onVoiceSent(rawText: string): void {
    const text = rawText.trim();
    if (!text || this.loading()) {
      return;
    }
    this.showVoiceRecorder.set(false);
    this.answerSubmitted.emit(text);
  }

  protected toggleVoiceRecorder(): void {
    this.showVoiceRecorder.update((value) => !value);
  }

  protected requestGenerate(): void {
    if (this.loading() || this.requiresMoreClarification()) {
      return;
    }
    this.generateRequested.emit();
  }

  protected loadingMessageKey(): string {
    return this.requiresMoreClarification()
      ? "mobile.aiQuestionnaire.clarify.thinking"
      : "mobile.aiQuestionnaire.clarify.generating";
  }
}
